import React, { useState } from 'react';
import { Form, Input, Button, Checkbox, Card, Typography, Divider, Alert, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import axios from 'axios';
import { baseUrl } from '../../config/apiConfig';
import { useNavigate } from "react-router-dom";
import authStore from "../../stores/AuthStore";
import tokenStore from '../../stores/TokenStore';

const { Title, Text, Link } = Typography;

const LoginPage = () => {
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    console.log('Success:', values);
    // Here you would typically make an API call to authenticate the user
    setLoading(true);

    const loginUrl = `${baseUrl}/user/login`;

    try {
      const response = await axios.post(loginUrl, values); // 登陆 API 端点
      const { token } = response.data.data;

      // 检查是否有 token
      if (token) {
        message.success("Login success");

        //存储token
        tokenStore.setToken(token);

        // 使用 authStore 管理登录状态
        authStore.login(); // 设置全局状态为 true

        navigate('/');
      } else {
        message.error('Invalid username or password. Please try again.');
      }
    } catch (error) {
      message.error('Login failed. Please try again later.' + error);
    } finally {
      setLoading(false);
    }



  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
    setError('Please check your email and password and try again.');
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      background: '#f0f2f5'
    }}>
      <Card style={{ width: 400, boxShadow: '0 4px 8px 0 rgba(0,0,0,0.2)' }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <Title level={2} style={{ marginBottom: 0 }}>TOMATO PAY</Title>
          <Text type="secondary">Log in to your account</Text>
        </div>

        <Form
          name="normal_login"
          initialValues={{ remember: true }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <Form.Item
            name="email"
            rules={[{ required: true, message: 'Please input your Email!' }]}
          >
            <Input prefix={<UserOutlined />} placeholder="Email" />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: 'Please input your Password!' }]}
          >
            <Input.Password prefix={<LockOutlined />} placeholder="Password" />
          </Form.Item>

          <Form.Item>
            <Form.Item name="remember" valuePropName="checked" noStyle>
              <Checkbox>Stay logged in</Checkbox>
            </Form.Item>
            <Link href="#" style={{ float: 'right' }}>Forgot password?</Link>
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" style={{ width: '100%' }} loading={loading}>
              Log In
            </Button>
          </Form.Item>

          {error && <Alert message={error} type="error" showIcon style={{ marginBottom: 24 }} />}
        </Form>

        <Divider plain>New to TOMATO PAY?</Divider>

        <Button style={{ width: '100%' }}>Sign Up</Button>
      </Card>
    </div>
  );
};

export default LoginPage;
